// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleMessage_container__FJwc5","message":"SimpleMessage_message__S4f0k","cta":"SimpleMessage_cta__mKimF"};